import { ContactHistoryView } from "../../../app/GeneratedApi";
import { TableHeaderCellsTypes } from "../../../components/Table/table.types";
import { ContactHistoryRow } from "./ContactHistoryTable.types";

const headerCells: TableHeaderCellsTypes<ContactHistoryRow>[] = [
  { propName: "day", label: "Day", isSortable: true, width: "120px" },
  { propName: "totalSent", label: "Total Sent", isSortable: true },
  { propName: "totalDelivered", label: "Total Delivered", isSortable: true },
  { propName: "totalUniqueOpens", label: "Unique Opens", isSortable: true },
  { propName: "totalUniqueClicks", label: "Unique Clicks", isSortable: true },
  { propName: "totalSoftBounces", label: "Soft Bounces", isSortable: true },
  { propName: "totalHardBounces", label: "Hard Bounces", isSortable: true },
  { propName: "totalUnsubscribes", label: "Unsubscribes", isSortable: true },
  {
    propName: "totalSpamComplaints",
    label: "Spam Complaints",
    isSortable: true,
  },
  { propName: "totalBlocked", label: "Blocked", isSortable: true },
  { propName: "totalSuppressed", label: "Suppressed", isSortable: true },
  { propName: "deliveryRate", label: "Delivery Rate", isSortable: true },
  { propName: "openRate", label: "Open Rate", isSortable: true },
  { propName: "clickRate", label: "Click Rate", isSortable: true },
  {
    propName: "clickToOpenRate",
    label: "Click to Open Rate",
    isSortable: true,
  },
  { propName: "unsubscribeRate", label: "Unsubscribe Rate", isSortable: true },
  { propName: "spamRate", label: "Spam Rate", isSortable: true },
  { propName: "bounceRate", label: "Bounce Rate", isSortable: true },
];

const formatDate = (timestamp: number): string => {
  return new Date(timestamp).toLocaleDateString();
};

const formatPercentage = (value: number): string => {
  return `${value.toFixed(1)}%`;
};

const transformDataToRows = (
  data: ContactHistoryView[]
): ContactHistoryRow[] => {
  return data.map((item) => ({
    day: formatDate(item.day),
    totalSent: item.sent.toString(),
    totalDelivered: item.delivered.toString(),
    totalUniqueOpens: item.uniqueOpens.toString(),
    totalUniqueClicks: item.uniqueClicks.toString(),
    totalSoftBounces: item.softBounce.toString(),
    totalHardBounces: item.hardBounce.toString(),
    totalUnsubscribes: item.unsubscribe.toString(),
    totalSpamComplaints: item.spam.toString(),
    totalBlocked: item.blocked.toString(),
    totalSuppressed: item.suppressed.toString(),
    deliveryRate: formatPercentage(item.deliveryRate),
    openRate: formatPercentage(item.openRate),
    clickRate: formatPercentage(item.clickRate),
    clickToOpenRate: formatPercentage(item.clickToOpenRate),
    unsubscribeRate: formatPercentage(item.unsubscribeRate),
    spamRate: formatPercentage(item.spamRate),
    bounceRate: formatPercentage(item.bounceRate),
  }));
};

export { headerCells, formatDate, formatPercentage, transformDataToRows };
